// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'parking-oradea',
    appId: '1:310365319706:web:bdd366cfa433b50eb5d7a3',
    storageBucket: 'parking-oradea.appspot.com',
    apiKey: 'AIzaSyCHFcs_srRCfYTV9jCbM3t9DmUyI5rpY9U',
    authDomain: 'parking-oradea.firebaseapp.com',
    messagingSenderId: '310365319706',
    measurementId: 'G-EN56RQYVEQ',
  },
  production: false,
  baseUrl: 'https://dev.parking.oradea.ro:40743',
  // baseUrl: 'https://localhost:2841'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
